const getters = {
  isExcursionTypesLoaded(state) {
    return state.types.length > 0;
  }
};

export default getters;
